import Page from "webPage/Page";

import Track from "util/Track";
import {handleTestimonials} from "util/handleTestimonials";

Page.register('page-template-location', () => {
    $("body").on("click", ".js-accordion-btn", function () {
        if ($(this).closest(".accordion").hasClass("accordion--active")) {
            $(this).closest(".accordion").toggleClass("accordion--active");
            $(this).closest(".accordion").find(".accordion__body").slideToggle();
        } else {
            $(".accordion--active").find(".accordion__body").slideUp();
            $(".accordion").removeClass("accordion--active");
            $(this).closest(".accordion").addClass("accordion--active");
            $(this).closest(".accordion").find(".accordion__body").slideToggle();
        }

    })

    $('.js-card-slider-wrap').each(function() {
        new Track($(this), {
            classes: {
                block: "card-slider",
            },
        });
    });

    handleTestimonials();
});
